import dynamic from 'next/dynamic'

export const BentoRectangleThreeParts = dynamic(
    () => import('./bento-rectangle-three-parts')
)
